import { contentCatalog, contentGeneration } from "../content/catalog"
import { resolvePopulationProfile } from "../content/population"
import { TileSize } from "../models"
import { Race } from "../character/character"
import { PsychProfile } from "../models"
import { EntityMechanics } from "./entity_mechanics"

export interface CreatureBaselineMeta {
    maxSpeed: number
    hp: number
    psych: PsychProfile
    scanDistanceTiles?: number
}

export class PopulationMechanics {
    private static engineValues = () => ({
        speed: EntityMechanics.speed, hp: EntityMechanics.hitPoints,
        hostility: EntityMechanics.psych.hostility(), tileSize: { minimum: TileSize },
    })
    private static resolved = new Map<Race, CreatureBaselineMeta>()
    private static generation = -1
    private static baseline = (race: Race): CreatureBaselineMeta => {
        if (this.generation !== contentGeneration()) {
            this.resolved.clear()
            this.generation = contentGeneration()
        }
        if (!this.resolved.has(race)) this.resolved.set(race, resolvePopulationProfile(contentCatalog.source, race, this.engineValues()) as CreatureBaselineMeta)
        return this.resolved.get(race)
    }

    static speed = (race: Race, pctOfMax: number = 1.0) => {
        const baseline = this.baseline(race)
        return baseline.maxSpeed * pctOfMax
    }

    static hp = (race: Race, pctOfMax: number = 1.0) => {
        const baseline = this.baseline(race)
        return baseline.hp * pctOfMax
    }

    static scanDistanceTiles = (race: Race) => {
        const baseline = this.baseline(race)
        return baseline.scanDistanceTiles || 5
    }

    static psych = (race: Race): PsychProfile => (this.baseline(race)).psych
}
